/*
 * A change the appliance undoes by itself unless the console confirms it, as
 * the firewall's are. It is confirmed only after a fresh read of the
 * appliance answers through the same path, so a change that cut this console
 * off is never confirmed and lapses on the appliance's own clock.
 */
import { fetchWithTimeout } from "./fetchWithTimeout";

export const LOST_TOUCH =
  "The box did not answer after the change, so it will put the settings before it back by itself within two minutes.";

/**
 * @param {(path: string) => string} url  the selected edge's API URL builder
 * @param {object} written                the write's answer, carrying change.id
 * @param {string} readPath               what to read back first
 * @param {string} confirmPath            where to confirm
 * @returns the appliance's answer to the confirmation
 */
export async function confirmChange(url, written, readPath, confirmPath) {
  const change = written?.change?.id;
  if (!change) throw new Error("The box did not say which change to keep, so it will undo it by itself.");
  const read = await fetchWithTimeout(url(readPath)).catch(() => null);
  if (!read || !read.ok) throw new Error(LOST_TOUCH);
  const res = await fetchWithTimeout(url(confirmPath), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ change }),
  }).catch(() => null);
  if (!res) throw new Error(LOST_TOUCH);
  if (!res.ok) {
    const why = (await res.text().catch(() => "")).trim();
    throw new Error(why || `The box would not keep the change (HTTP ${res.status}), so it will undo it by itself.`);
  }
  return res.json().catch(() => null);
}
